import script from "./EndorsersView.vue?vue&type=script&setup=true&lang=js"
export * from "./EndorsersView.vue?vue&type=script&setup=true&lang=js"

import "./EndorsersView.vue?vue&type=style&index=0&id=f659ceb4&scoped=true&lang=css"

import exportComponent from "/builds/skilltech-ph/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f659ceb4"]])

export default __exports__